module.exports = __webpack_public_path__ + "img/land-of-lions.4358f653.webp";